import { toast } from 'material-react-toastify';

import { hubApi, withAuthHeader } from '@/lib/backend/api';
import { getAuthToken } from '@/lib/firebase/token';
import { subscriptionKeys } from '@/lib/query/keys/subscription';
import { SubscriptionDetails } from '@addmile/backend-client';
import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';

export const useUserSubscriptions = (userId: string | undefined) => {
  return useQuery<SubscriptionDetails[]>({
    queryKey: userId ? subscriptionKeys.byUser(userId) : ['subscriptions', 'disabled'],
    queryFn: async () => {
      if (!userId) return [];
      try {
        const token = await getAuthToken();
        const {
          data: { subscriptions },
        } = await hubApi.getSubscriptionsHub(
          userId,
          undefined,
          undefined,
          undefined,
          undefined,
          withAuthHeader(token),
        );

        return subscriptions;
      } catch (error) {
        Sentry.captureException(`Failed to fetch subscriptions: ${error.message}`);
        toast.error(`Failed to fetch subscriptions: ${error.message}`);
        return [];
      }
    },
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
  });
};
